import React, { memo } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { DEFAULT_OG_IMAGE } from '../../seo/siteConfig'
import { resolveSeo } from '../../seo/routeSeo'

function PageSeo({ title, description, canonical, h1, jsonLd }) {
  const { pathname } = useLocation()
  const resolved = resolveSeo(pathname)
  const pageTitle = title || resolved.title
  const pageDescription = description || resolved.description
  const pageCanonical = canonical || resolved.canonical
  const pageH1 = h1 || resolved.h1

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageCanonical} />
        <meta property="og:url" content={pageCanonical} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />
        {jsonLd ? (
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        ) : null}
      </Helmet>
      <span className="visually-hidden" id="page-seo-h1">{pageH1}</span>
    </>
  )
}

export default memo(PageSeo)
